import React, { useState, useEffect } from 'react';
import getFacility from '../../shared/api/getFacility';
import ContactMain from '../components/ContactMain';
import OtherContactMain from '../components/OtherContactMain';

const Contact = () => {
  const [isLogin, setLogin] = useState<boolean>(false);

  useEffect(() => {
    const fetchFacility = async () => {
      try {
        await getFacility();
        setLogin(true);
      } catch {
        setLogin(false);
      }
    };

    fetchFacility();
  }, []);

  return (
    <React.Fragment>
      { isLogin ? <ContactMain /> : <OtherContactMain /> }
    </React.Fragment>
  );
};

export default Contact;